import React, { JSX, useEffect, useState } from 'react';
import { isInWishlist, subscribeToWishlist, toggleWishlist } from '../Util/wishlistStorage';
import { useTranslation } from '@ibe/components';
import Keys from '../Translations/generated/wishlist-content.de.json.keys';
import fallback from '../Translations/generated/wishlist-content.de.json';

interface WishlistToggleProps {
  productId?: string;
  className?: string;
  size?: number;
}

const WishlistToggle = ({
  productId,
  className = '',
  size = 48
}: WishlistToggleProps): JSX.Element | null => {
  const [isActive, setIsActive] = useState<boolean>(() =>
    productId ? isInWishlist(productId) : false
  );
  const { t } = useTranslation('wishlist-content', fallback);

  useEffect(() => {
    if (!productId) {
      return;
    }

    setIsActive(isInWishlist(productId));

    return subscribeToWishlist(() => {
      setIsActive(isInWishlist(productId));
    });
  }, [productId]);

  if (!productId) {
    return null;
  }

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
    event.preventDefault();
    event.stopPropagation();

    setIsActive(toggleWishlist(productId));
  };

  return (
    <button
      type="button"
      className={['product-teaser__wishlist-toggle', isActive ? 'is-active' : '', className]
        .filter(Boolean)
        .join(' ')}
      style={{ width: size, height: size }}
      data-wishlist-product-id={productId}
      aria-pressed={isActive}
      aria-label={isActive ? t(Keys.remove) : t(Keys.add)}
      onClick={handleClick}
    >
      <i
        className="far fa-heart product-teaser__wishlist-toggle__icon product-teaser__wishlist-toggle__icon--outline"
        aria-hidden="true"
      />
      <i
        className="fas fa-heart product-teaser__wishlist-toggle__icon product-teaser__wishlist-toggle__icon--filled"
        aria-hidden="true"
      />
    </button>
  );
};

export default WishlistToggle;
